module.exports = __webpack_public_path__ + "static/back_event_05-c2dc21d2a7358d3cdec13d19d2f51cb8.jpg";